import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-[900px] mx-auto px-6 py-32 text-center" data-testid="payment-cancel">
      <div className="overline text-emerald">No charges made</div>
      <h1 className="mt-3 font-serif text-5xl tracking-tight">Payment cancelled.</h1>
      <p className="mt-4 text-charcoal/70">Your bag is still saved — try again whenever you're ready.</p>
      <Link to="/cart" className="mt-8 inline-block overline text-emerald">Return to cart</Link>
    </div>
  );
}
